module.exports = __webpack_public_path__ + "media/images/fbcalls/fbcalls_logo-bd2c7b584458faa3c5f0e00f0f2d7ff9.png";